<template>
    <div id="settings-menu">
        <ul>
            <li v-if="hasAllRoles(['DeviceView'])">
                <router-link to="/settings/devices" class="devices">
                    <sp-button icon="settings" text="Open Fleet Devices"></sp-button>
                </router-link>
            </li>
            <li v-if="hasAllRoles(['FleetView'])">
                <router-link to="/settings/fleets" class="fleets">
                    <sp-button icon="car" text="Fleet Management"></sp-button>
                </router-link>
            </li>
            <li v-if="hasAllRoles(['UserView'])">
                <router-link to="/settings/users" class="users">
                    <sp-button icon="user" text="User Management"></sp-button>
                </router-link>
            </li>
            <li v-if="hasAllRoles(['DriverView'])">
                <router-link to="/settings/drivers" class="drivers">
                    <sp-button icon="driver" text="Driver Management"></sp-button>
                </router-link>
            </li>
            <li v-if="hasAllRoles(['OrganizationView']) && !activeImpersonate">
                <router-link to="/settings/organizations" class="organizations">
                    <sp-button icon="driver" text="Organizations Management"></sp-button>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>

import SpButton from '@/components/forms/Button'
import { mapGetters } from 'vuex'

export default {
    name: 'SettingsMenu',
    components: {
        SpButton
    },
    computed: {
        ...mapGetters('authModule', [
            'getActiveOrganization',
            'getDefaultOrganization'
        ]),
        activeImpersonate () {
            return this.getActiveOrganization !== this.getDefaultOrganization
        }
    }
}
</script>

<style scoped lang="scss">
#settings-menu {
    list-style: none;
    margin: 0;
    padding: 50px 0 0 0;
    // display: flex;
    // flex-wrap: wrap;

    ul {
        display: flex;
        padding-left: 0;
        flex-wrap: wrap;
        li {
            display: flex;
            margin: 10px 20px 0 0;

            &:last-child {
                margin-right: 0;
            }
            a {
                text-decoration: none;
            }
        }
    }
}
</style>
